<i class="far fa-crosshairs" data-fa-symbol="crosshair"></i>
<i class="far fa-edit" data-fa-symbol="edit"></i>
<i class="far fa-trash-alt" data-fa-symbol="trash"></i>
<i class="far fa-crosshairs" data-fa-symbol="crosshair"></i>
<i class="far fa-comments" data-fa-symbol="comments"></i>
<i class="fas fa-flag" data-fa-symbol="flag"></i>
<i class="fas fa-times" data-fa-symbol="times"></i>

<div class="actions-wrapper">
  <label [title]="getPushToggleTitle()" [class]="isPushFailed() ? 'push-failed' : ''">
    <input type="checkbox" (click)="togglePush()" [checked]="isPushEnabled()" />
    {{'Desktop notifications' | translate}}
  </label>
</div>

<div class="table-container" *ngIf="!formData">
  <div style=" margin-bottom: 0.2em; overflow: auto;" *qmLoading="loading">
    <div #notification [attr.data-id]='single.id' *ngFor="let single of notificationList"
         [style.border-bottom]="getColor(single.createdAt)">
      <div class="d-flex flex-row">
        <div *ngIf="isFlagged(single)" class="state-block flagged">
          <span>
            <svg class="svg-inline--fa fa-w-20">
              <use xlink:href="#flag"></use>
            </svg>
          </span>
        </div>
        <div *ngIf="single.state === 'new' && !isFlagged(single)" [ngClass]="single.state" class="state-block">
          {{'New' | translate}}
        </div>
        <div *ngIf="single.state === 'updated' && !isFlagged(single)" [ngClass]="single.state" class="state-block">
          {{'Updated' | translate}}
        </div>

        <div class="d-flex flex-column notification">
          <div class="d-flex flex-column notification" (click)="setActive(single)">
            <div class="small-text d-flex flex-row justify-content-between">
              <span *ngIf="single.userName">{{ single.userName }}</span>
              <span *ngIf="single.mapObjectId">{{ single.mapObjectId.split('_')[1] }}</span>
              <span ngbTooltip="{{single.updatedAt | qmDateDistance}}">
                {{single.updatedAt | qmDateFormat:'HH:mm | dd.MM.yyyy'}}
              </span>
            </div>
            <div class="d-flex flex-row justify-content-between">
              <div>
                <span class="d-flex flex-start">{{single.description | qmLink}}</span>
              </div>
              <div *ngIf="single.comments.length > 0" class="comment-counter">
                <svg class="svg-inline--fa fa-w-20">
                  <use xlink:href="#comments"></use>
                </svg>
                <span class="badge badge-pill badge-success">{{single.comments.length}}</span>
              </div>
            </div>
            <div class="small-text d-flex flex-row" *ngIf="isActive(single)">
              <div class="icons" (click)="editNotification(single)" *qmAuth="'button_write'">
                <svg class="svg-inline--fa fa-w-20">
                  <use xlink:href="#edit"></use>
                </svg>
              </div>
              <div class="icons" (click)="deleteNotification(single)" *qmAuth="'button_write'">
                <svg class="svg-inline--fa fa-w-20">
                  <use xlink:href="#trash"></use>
                </svg>
              </div>
              <div class="icons" (click)="flagNotification(single)" *qmAuth="'button_write'">
                <svg class="svg-inline--fa fa-w-20">
                  <use xlink:href="#flag"></use>
                </svg>
              </div>
            </div>
          </div>

          <div class="comment-block2" *ngIf="isActive(single)">
            <div class="d-flex flex-column comment" *ngFor="let comment of single.comments">
              <div class="small-text d-flex flex-row justify-content-between" style="padding: 0.2em;">
                <div>
                  {{comment.userName}}
                </div>
                <div ngbTooltip="{{comment.updatedAt | qmDateDistance}}">
                  {{comment.updatedAt | qmDateFormat:'HH:mm | dd.MM.yyyy'}}
                </div>
              </div>
              <div>
                <div *ngIf="!editCom">
                  <span class="d-flex flex-start" style="font-size: 0.8em;" [innerHTML]="comment.comment | linky"></span>
                </div>
                <div class="input-block d-flex flex-row" *ngIf="editCom">
                  <div *qmAuth="'button_write'">
                    <button type="button" class="btn btn-outline-success"
                            (click)="saveComment(newComment, single); editCom = false">
                      {{'Save' | translate}}
                    </button>
                  </div>
                  <div *qmAuth="'button_write'">
                    <button type="button" class="btn btn-outline-warning custom" (click)="editCom = false; activeCommentId = null;">
                      {{'Cancel' | translate}}
                    </button>
                  </div>
                  <div *qmAuth="'button_write'">
                  <textarea class="form-control" rows="1" cols="100" style="font-size: 1.1em;"
                            (keyup.enter)="saveComment(newComment, single)"
                            [(ngModel)]="newComment.comment" placeholder="{{'New comment' | translate}}"></textarea>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-start flex-row small-text">
                <a [attr.data-btnId]="getElementId('editComment')" *ngIf="userName === comment.userId" class="icons"
                   (click)="editComment(comment)">
                  <svg class="svg-inline--fa fa-w-20">
                    <use xlink:href="#edit"></use>
                  </svg>
                </a>
                <a [attr.data-btnId]="getElementId('deleteComment')" *ngIf="userName === comment.userId" class="icons"
                   (click)="deleteComment(comment)" style="text-align: center;">
                  <svg class="svg-inline--fa fa-w-20">
                    <use xlink:href="#trash"></use>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <div *ngIf="isActive(single)" class="comment-field">
            <div class="input-block d-flex flex-row">
              <div *qmAuth="'button_write'">
                <button type="button" class="btn btn-outline-success" (click)="saveComment(newComment, single)">
                  {{'Save' | translate}}
                </button>
              </div>
              <div *qmAuth="'button_write'">
              <textarea class="form-control" rows="1" cols="100" style="font-size: 1.1em;"
                        (keyup.enter)="saveComment(newComment, single)"
                        [(ngModel)]="newComment.comment" placeholder="{{'New comment' | translate}}"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="wrapper" *ngIf="formData">
  <div class="table-container form">
    <div class="d-flex align-content-start" *ngIf="formData.mapObjectId">
      <span>{{'Element' | translate}}: {{formData.mapObjectId}}</span>
    </div>
    <div class="d-flex textarea">
        <textarea class="form-control" id="defTextarea" placeholder="{{'Description' | translate}}" rows="3"
                  [(ngModel)]="formData.description"></textarea>
    </div>
    <div class="d-flex buttons">
      <div class="d-flex justify-content-center">
        <button [attr.data-btnId]="getElementId('save')" class="btn btn-outline-success" (click)="save(formData)">
          {{'Save' | translate}}
        </button>
      </div>
      <div class="d-flex justify-content-center">
        <button [attr.data-btnId]="getElementId('cancel')" class="btn btn-outline-warning" (click)="cancel()">
          {{'Cancel' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>
